export enum LocationRoutes {
    LocationCreate = 'create',
    LocationList = ''
}
